import { render } from "./Nav.vue?vue&type=template&id=7be14987&scoped=true"
const script = {}

import "./Nav.vue?vue&type=style&index=0&id=7be14987&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src286570729/src/astaykov-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be14987"]])

export default __exports__